import { useNavigate } from "react-router-dom"

import LicenseIcon from "@mui/icons-material/CardMembership"
import { useMediaQuery } from "@mui/material"

import { Button, Snackbar } from "@synapse-analytics/synapse-ui"
import moment from "moment"

import { routes } from "../../../routes/routes"
import { useLicenseStore } from "../../../store"

import styles from "./ExpiryWarning.module.scss"

const ExpiryWarning = () => {
  const [licenseInfo, setIsWarningDisplayed] = useLicenseStore((state) => [
    state.licenseInfo,
    state.setIsWarningDisplayed,
  ])

  const now = moment().startOf("day")
  const expirationDate = moment(licenseInfo?.valid_until).startOf("day")
  const daysLeft = Math.max(expirationDate.diff(now, "days"), 0)

  const navigate = useNavigate()

  const smallScreen = useMediaQuery("(max-width:1100px)")

  return (
    <Snackbar
      severity="warning"
      className={styles.expirationSnackbar}
      removable
      onRemove={() => setIsWarningDisplayed(false)}
      showSeverityIcon={false}
    >
      <div className={styles.expirationWarning}>
        <LicenseIcon fontSize="small" />
        <span className={styles.expirationText}>
          Your License expires in {daysLeft} days!
          {!smallScreen &&
            " Please reach out to the Azkavision team to renew your license and ensure uninterrupted access to our services."}
        </span>
        <Button onClick={() => navigate(`/${routes?.license}`)} variant="ghost">
          License Details
        </Button>
      </div>
    </Snackbar>
  )
}
export default ExpiryWarning
